import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Type } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SectionConfiguration } from '../process';

@Component({
  selector: 'smw-process-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgComponentOutlet, NgTemplateOutlet],
})
export class ProcessMenuComponent {
  sections = input<SectionConfiguration[]>();
  steps = input<string[]>();
  /** Mapping between step identifiers and the associated menu item components */
  menuItemComponentsMapping = input.required<Record<string, Type<unknown> | undefined>>();

  noSection = computed(() => !this.sections()?.length);
}
